import { providersSlice } from './slice'
import axios from 'axios'
import { API_INTERFACE } from '../../../services/constants'

interface ProviderByNpiNetworkLatLong {
  npi: string | number
  network: string
  lat: string | number
  long: string | number
}

const providerDomainApi = axios.create({ baseURL: process.env.CAREPOINT_URL || process.env.REACT_APP_CAREPOINT_URL });

const { loadProvider, setProvider, clearProvider, reset } =
  providersSlice.actions

const findEffectiveProvider = (providers: any[]) => {
  const today = new Date()

  return providers.find(
    provider =>
      !provider.endDate ||
      (provider.endDate !== null && new Date(provider.endDate)) > today
  )
}

export const fetchProviderByNpiNetworkLatLong =
  (props: ProviderByNpiNetworkLatLong) => async (dispatch: any) => {
    const { npi, network, lat, long } = props
    dispatch(loadProvider())
    let providers: any[] = []

    const params = {
      npi,
      networks: network,
      lat,
      long
    }

    try {
      const response = await providerDomainApi.get(API_INTERFACE.FETCH_OPENSEARCH_PROVIDERS, { params })
      providers = response?.data?.data
    } catch (e) {
      console.error(e)
    } finally {
      const provider = findEffectiveProvider(providers)

      dispatch(setProvider(provider || {}))
    }
  }

export const selectProvider = (provider: any) => async (dispatch: any) => {
  dispatch(setProvider(provider))
}

export const clearSelectedProvider = () => async (dispatch: any) => {
  dispatch(clearProvider())
}

export const resetProviders = () => async (dispatch: any) => {
  dispatch(reset())
}
